/* Optical Incanto — detach desktop Impulse search from the collapsed native header. */
(function () {
  'use strict';

  var mq = window.matchMedia('(min-width: 990px)');
  var container = null;
  var originalParent = null;
  var originalNext = null;
  var observer = null;

  function getContainer() {
    if (!container) container = document.querySelector('.site-header__search-container');
    return container;
  }

  function updateTop() {
    var el = getContainer();
    if (!el || !mq.matches) return;

    var bar = document.getElementById('oi-header-bar');
    var top = 0;

    if (bar && window.getComputedStyle(bar).display !== 'none') {
      top = Math.max(0, Math.round(bar.getBoundingClientRect().bottom));
    } else {
      var header = document.getElementById('SiteHeader');
      if (header) top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }

    el.style.setProperty('--oi-search-top', top + 'px');
  }

  function mount() {
    var el = getContainer();
    if (!el || !mq.matches) return;

    if (!el.classList.contains('oi-search-detached')) {
      originalParent = el.parentNode;
      originalNext = el.nextSibling;
      document.body.appendChild(el);
      el.classList.add('oi-search-detached');
    }

    updateTop();

    if (!observer) {
      observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class' && el.classList.contains('is-active')) {
            updateTop();
          }
        });
      });
      observer.observe(el, { attributes: true, attributeFilter: ['class'] });
    }
  }

  function restore() {
    var el = getContainer();
    if (!el || mq.matches || !el.classList.contains('oi-search-detached')) return;

    el.classList.remove('oi-search-detached');
    el.style.removeProperty('--oi-search-top');

    if (originalParent) {
      if (originalNext && originalNext.parentNode === originalParent) {
        originalParent.insertBefore(el, originalNext);
      } else {
        originalParent.appendChild(el);
      }
    }
  }

  function sync() {
    if (mq.matches) mount();
    else restore();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  window.addEventListener('resize', function () {
    sync();
    if (mq.matches) updateTop();
  }, { passive: true });

  window.addEventListener('scroll', function () {
    var el = getContainer();
    if (mq.matches && el && el.classList.contains('is-active')) updateTop();
  }, { passive: true });

  document.addEventListener('click', function (event) {
    if (!mq.matches) return;
    if (event.target.closest('.js-search-header')) {
      mount();
      updateTop();
    }
  }, true);
})();
